export default "__VITE_ASSET__a51eb779__"